import { createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex border-b mb-5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "py-4 text-center text-gray-500"
}
const _hoisted_4 = {
  key: 2,
  class: "overflow-y-auto",
  style: {"max-height":"380px"}
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["id", "checked", "onChange"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "font-medium text-gray-800" }
const _hoisted_9 = { class: "text-gray-400 ml-2 text-sm" }
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col gap-4"
}
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-gray-600 mb-1" }, [
  /*#__PURE__*/_createTextVNode("Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-gray-600 mb-1" }, [
  /*#__PURE__*/_createTextVNode("Supplier "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select supplier", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-gray-600 mb-1" }, "Service", -1)
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-gray-600 mb-1" }, "Country", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "No country (optional)", -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "flex flex-col" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-gray-600 mb-1" }, [
  /*#__PURE__*/_createTextVNode("Price "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_25 = { class: "flex flex-col w-40" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-gray-600 mb-1" }, "Gross margin (%)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.show) = $event)),
    onConfirmClick: _ctx.handleConfirm,
    "block-confirm": !_ctx.canConfirm,
    "hide-buttons": false
  }, {
    title: _withCtx(() => [
      _createTextVNode("Add Surcharge")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: _normalizeClass(["pb-2 mr-6 font-medium text-sm border-b-2 transition-colors", _ctx.activeTab === 'existing' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'existing'))
          }, " Select existing ", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["pb-2 font-medium text-sm border-b-2 transition-colors", _ctx.activeTab === 'create' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'create'))
          }, " Create new ", 2)
        ]),
        (_ctx.activeTab === 'existing')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.isLoadingSurcharges)
                ? (_openBlock(), _createBlock(_component_content_loader, {
                    key: 0,
                    label: "general.loading"
                  }))
                : (!_ctx.availableSurcharges.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, " All surcharges from the cost price list are already added to this proposal. "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableSurcharges, (surcharge) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: surcharge.id,
                          class: "flex items-center py-3 border-b border-gray-100 cursor-pointer hover:bg-gray-50",
                          onClick: ($event: any) => (_ctx.toggleSelection(surcharge.id))
                        }, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            id: `surcharge-${surcharge.id}`,
                            checked: _ctx.selectedIds.includes(surcharge.id),
                            onChange: ($event: any) => (_ctx.toggleSelection(surcharge.id)),
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                            class: "mr-3 cursor-pointer"
                          }, null, 40, _hoisted_6),
                          _createElementVNode("label", {
                            for: `surcharge-${surcharge.id}`,
                            class: "flex-1 cursor-pointer"
                          }, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(surcharge.name), 1),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(surcharge.supplier), 1)
                          ], 8, _hoisted_7)
                        ], 8, _hoisted_5))
                      }), 128))
                    ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'create')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newSurcharge.name) = $event)),
                  placeholder: "Surcharge name",
                  class: "border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-blue-400"
                }, null, 512), [
                  [_vModelText, _ctx.newSurcharge.name]
                ])
              ]),
              (_ctx.supplierOptions.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newSurcharge.supplierId) = $event)),
                      class: "border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-blue-400 bg-white"
                    }, [
                      _hoisted_15,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supplierOptions, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.id,
                          value: option.id
                        }, _toDisplayString(option.name), 9, _hoisted_16))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.newSurcharge.supplierId]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newSurcharge.serviceName) = $event)),
                  placeholder: "e.g. All (optional)",
                  class: "border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-blue-400"
                }, null, 512), [
                  [_vModelText, _ctx.newSurcharge.serviceName]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newSurcharge.countryId) = $event)),
                  class: "border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-blue-400 bg-white"
                }, [
                  _hoisted_21,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCountries, (country) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: country.id,
                      value: country.id
                    }, _toDisplayString(country.name), 9, _hoisted_22))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.newSurcharge.countryId]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newSurcharge.priceAmount) = $event)),
                  placeholder: "0.00",
                  min: "0",
                  step: "0.01",
                  class: "border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-blue-400"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.newSurcharge.priceAmount,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newSurcharge.grossMargin) = $event)),
                  placeholder: "0",
                  min: "0",
                  step: "0.1",
                  class: "border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-blue-400"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.newSurcharge.grossMargin,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onConfirmClick", "block-confirm"]))
}